import Localization from "../../localization";
import { Form, Text } from "../../components";
import { useAuth } from "../../hooks";
import { useRef } from "react";
import { App } from "antd";

const fields = [
  {
    type: "email",
    name: ["data", "username"],
    placeholder: "name@example.com",
    label: Localization.general.email_address,
    rules: [
      {
        type: "email",
        required: true,
        message: Localization.feedback.invalid_email,
      },
    ],
  },
  {
    type: "password",
    name: ["data", "password"],
    label: Localization.general.password,
    placeholder: Localization.general.type_password,
    rules: [
      {
        min: 4,
        required: true,
        message: Localization.feedback.invalid_password,
      },
    ],
  },
];

const Login = ({
  onRegisterClick = () => {},
  onForgetPassClick = () => {},
  onLogin = async () => {},
}) => {
  const { message } = App.useApp();
  const { login } = useAuth();
  const formRef = useRef();

  return (
    <div>
      <Form fields={fields} ref={formRef} />
      <Form.Submit
        type="primary"
        title={Localization.general.login}
        className="w-100 m-25-t"
        onClick={async () => {
          try {
            await formRef.current.validateFields();
            await login(formRef.current.getFieldValue("data"));
            await onLogin();
          } catch (error) {
            message.error(
              !!error?.errorFields?.length
                ? Localization.feedback.empty_fields
                : error.message
            );
          }
        }}
      />
      <Text color="secondary" className="text-align-center m-20-t">
        {Localization.login.footer + " "}
        <Text
          underline
          level="link"
          weight={"600"}
          onClick={onRegisterClick}
          children={Localization.general.register}
        />
      </Text>
      <Text
        underline
        weight={"600"}
        onClick={onForgetPassClick}
        className="text-align-center m-15-t cursor-pointer"
        children={Localization.general.forgot_password}
      />
    </div>
  );
};

export default Login;
